export default "__VITE_ASSET__VIrsLUTq__"